const STORAGE_KEY = "fashion_visited_categories";
const MAX_CATEGORIES = 5;

/**
 * Returns the list of recently visited category handles (most recent last).
 */
export function getVisitedCategories() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Adds a category handle to the visited list.
 * Deduplicates and caps at MAX_CATEGORIES.
 * @param {string} handle - category handle string
 */
export function addVisitedCategory(handle) {
  if (!handle) return;
  try {
    const categories = getVisitedCategories().filter((h) => h !== handle);
    categories.push(handle);
    if (categories.length > MAX_CATEGORIES) categories.shift();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
    // Notify other components (e.g. FashionBrowsePopup) in the same tab
    window.dispatchEvent(new CustomEvent("visitedCategoriesUpdated", { detail: categories }));
  } catch {}
}

/**
 * Returns the most recently visited category handle, or null if none.
 */
export function getLatestCategory() {
  const cats = getVisitedCategories();
  return cats.length ? cats[cats.length - 1] : null;
}
